export default "__VITE_ASSET__0ef96e20__"